import React, { useState, useEffect } from 'react';
import { FaTrash } from 'react-icons/fa';
import { ImportantButton } from 'components';
import './HelpWordTableSection.css';

const DEMO_ROWS = [
  { word: 'ephemeral', definition: 'lasting for only a short time' },
  { word: 'ubiquitous', definition: 'present, appearing, or found everywhere' },
  { word: 'serendipity', definition: 'the occurrence of events by chance in a happy way' },
];

const HelpWordTableSection = ({ onBack }) => {
  const [rows, setRows] = useState(DEMO_ROWS);
  const [isNarrow, setIsNarrow] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsNarrow(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="help-page">
      <div className="help-word-table-section">
        <p className="help-hint" style={{ marginBottom: 16 }}>
          This is your word list. Click <FaTrash style={{ verticalAlign: 'middle' }} /> to remove a word.
        </p>
        <div className="word-list-container">
          <table className="word-list-table">
            <thead>
              <tr>
                {isNarrow ? (
                  <>
                    <th>Word / Definition</th>
                    <th></th>
                  </>
                ) : (
                  <>
                    <th>Word</th>
                    <th>Definition</th>
                    <th></th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.word}>
                  {isNarrow ? (
                    <td>
                      <div className="word-text">{row.word}</div>
                      <div className="definition-text">{row.definition}</div>
                    </td>
                  ) : (
                    <>
                      <td>{row.word}</td>
                      <td>{row.definition}</td>
                    </>
                  )}
                  <td className="delete-cell">
                    <FaTrash
                      className="delete-icon"
                      onClick={() => setRows((prev) => prev.filter((r) => r.word !== row.word))}
                    />
                  </td>
                </tr>
              ))}
              {rows.length === 0 && (
                <tr>
                  <td colSpan={isNarrow ? 2 : 3} style={{ textAlign: 'center', color: '#888', padding: 16 }}>
                    No words left.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div style={{ marginTop: 20 }} className={"back-button"}>
          <ImportantButton buttonText="Back" onClick={onBack} />
        </div>
      </div>
    </div>
  );
};

export { HelpWordTableSection };
